'use strict';

module.exports = {
  startupLog: function startupLog() {},
  setStartupLogConfig: function setStartupLogConfig() {},
  setStartupLogInstrumenter: function setStartupLogInstrumenter() {},
  setSamplingRules: function setSamplingRules() {}
};